import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";

const ExportLeaderboardData = ({ transactions }) => {
  const [csvData, setCsvData] = useState([]);

  // :::: EXPORT TRANSACTIONS :::::
  useEffect(() => {
    // EXPORTING THE DATA INTO CSV FILE
    const toCSV = [];
    for (let i = 0; i < transactions.length; i++) {
      let obj = {};

      obj["customer"] = transactions[i]?.name;
      obj["contact"] = transactions[i]?.userId;
      obj["location"] = transactions[i]?.location;
      obj["points"] = transactions[i]?.loyaltyPoints;

      toCSV.push(obj);
    }

    setCsvData(toCSV);
  }, [transactions]);

  const reportHeader = [
    { label: "Customer", key: "customer" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Points", key: "points" },
  ];

  const csvFile = {
    filename: "leaderboard.csv",
    headers: reportHeader,
    data: csvData,
  };

  return (
    <div className="ml-4">
      <CSVLink
        {...csvFile}
        className="flex items-center bg-[#3989DD] border text-white rounded py-1.5 px-3 hover:shadow-lg"
        type="button"
      >
        <span className="px-1 pb-1  pl-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_371_37)">
              <path d="M6 0.5625V7.875" stroke="white" strokeMiterlimit="10" />
              <path
                d="M4.125 2.4375L6 0.5625L7.875 2.4375"
                stroke="white"
                strokeMiterlimit="10"
                // strokeMiterlimit="square"
              />
              <path
                d="M7.5 4.875H9.375C9.62364 4.875 9.8621 4.97377 10.0379 5.14959C10.2137 5.3254 10.3125 5.56386 10.3125 5.8125V10.5C10.3125 10.7486 10.2137 10.9871 10.0379 11.1629C9.8621 11.3387 9.62364 11.4375 9.375 11.4375H2.625C2.37636 11.4375 2.1379 11.3387 1.96209 11.1629C1.78627 10.9871 1.6875 10.7486 1.6875 10.5V5.8125C1.6875 5.56386 1.78627 5.3254 1.96209 5.14959C2.1379 4.97377 2.37636 4.875 2.625 4.875H4.5"
                stroke="white"
                strokeMiterlimit="10"
                // strokeMiterlimit="square"
              />
            </g>
            <defs>
              <clipPath id="clip0_371_37">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>

        <span className="text-base px-1.5 hidden md:block">
          Export Leaderboard
        </span>
      </CSVLink>
    </div>
  );
};

export default ExportLeaderboardData;
